import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const TeamSection = () => {
  return (
    <section className="team-section fix section-padding section-bg-2">
      <div className="container">
        <div className="section-title text-center">
          <h5 className="wow fadeInUp">
            <i className="flaticon-home"></i> OUR TEAM{" "}
            <i className="flaticon-home"></i>
          </h5>
          <h2 className="text-white wow fadeInUp" data-wow-delay=".3s">
            Meet the Faces Behind Shree JRB
          </h2>
        </div>

        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: ".array-next",
            prevEl: ".array-prev",
          }}
          spaceBetween={30}
          slidesPerView={3}
          loop={true}
          className="st-team-slider"
        >
          <SwiperSlide>
            <div className="st-team-thumb-items">
              <img src="/img/Babulal ji Saini.jpeg" alt="img" />
              <div className="st-team-content">
                <h3>
                  <a href="/">Mr. Babulal ji Saini (Dada)</a>
                </h3>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="st-team-thumb-items">
              <img src="/img/R.K.Kumawat ji.jpeg" alt="img" />
              <div className="st-team-content">
                <h3>
                  <a href="/">R.K.Kumawat ji</a>
                </h3>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="st-team-thumb-items">
              <img src="/img/Mr.M.K.Dadarwal.jpeg" alt="img" />
              <div className="st-team-content">
                <h3>
                  <a href="/">Mr.M.K.Dadarwal</a>
                </h3>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="st-team-thumb-items">
              <img src="/img/B.L.jpeg" alt="img" />
              <div className="st-team-content">
                <h3>
                  <a href="/">B.L Sharma</a>
                </h3>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="st-team-thumb-items">
              <img src="/img/Singer Rahul Sain.jpeg" alt="img" />
              <div className="st-team-content">
                <h3>
                  <a href="/">Singer Rahul Sain</a>
                </h3>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="st-team-thumb-items">
              <img src="/img/Sharad Runwal.jpeg" alt="img" />
              <div className="st-team-content">
                <h3>
                  <a href="/">Sharad Runwal</a>
                </h3>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>

        <div className="st-array-button justify-content-center mt-5">
          <button className="array-prev">
            <i className="fa-solid fa-chevron-left"></i>
          </button>
          <button className="array-next">
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
